/**
 * SCWT-PM-V2 Phase 5 — Landlord magic-link verify.
 * Route: /landlord/verify/:token
 */
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2, AlertTriangle } from "lucide-react";
import axios from "axios";

export default function LandlordVerify() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const base = process.env.REACT_APP_BACKEND_URL;
        await axios.post(`${base}/api/public/landlord/auth/verify`, { token },
          { withCredentials: true });
        navigate("/landlord");
      } catch (e) {
        setError(e?.response?.data?.detail || "invalid_or_expired_token");
      }
    })();
  }, [token, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
        <div data-testid="landlord-verify-error" className="bg-white rounded-2xl border border-rose-100 p-8 text-center max-w-md">
          <AlertTriangle className="w-8 h-8 text-rose-600 mx-auto" />
          <h1 className="text-xl font-bold text-slate-900 mt-4">Sign-in link is no longer valid</h1>
          <p className="text-slate-600 mt-2 text-sm">Please return to the login page and request a fresh link.</p>
          <a href="/landlord/login" className="inline-block mt-6 text-sm font-semibold text-cyan-700 hover:text-cyan-900">Back to sign-in →</a>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <Loader2 className="w-6 h-6 animate-spin text-cyan-700" />
    </div>
  );
}
